import styled from '@emotion/styled'
import React from 'react'
import PropTypes from 'prop-types'

const FieldName = styled.p`
  color: #90A1B0;
  width: 37%;
`
const FieldValue = styled.p`
  width: 63%;
`

const FieldContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 8px 0;
`

const ProfileField = ({name, value}) => (
  <FieldContainer>
    <FieldName>{name}</FieldName>
    <FieldValue>{value}</FieldValue>
  </FieldContainer>
)
ProfileField.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string
}

export default ProfileField